module.exports = __webpack_public_path__ + "./images/01688e9a88b341a3a47087b312e33b19.webp";